"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const utils_1 = require("./utils");
const Ticket_1 = require("./Ticket");
const Card_1 = require("@dialogexe/cw-component-card/Card");
const watchList_1 = require("@dialogexe/cw-website-store/watchList");
const tickets_1 = require("@dialogexe/cw-website-store/tickets");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const moment = require("moment");
require("moment/locale/nn");
require("moment/locale/nb");
class MyPage extends React.Component {
    constructor(props) {
        super(props);
        this.myWatchlistItemsPerPage = 8;
        this.myTicketsItemsPerPage = 8;
        this.state = {
            selectedCategory: null,
            profile: null,
            watchList: null,
            events: null,
            myWatchlistItemsDisplayed: this.myWatchlistItemsPerPage,
            myTicketsItemsDisplayed: this.myTicketsItemsPerPage
        };
        this.componentDidMount = () => {
            if (typeof window !== 'undefined' && window.localStorage) {
                const profile = JSON.parse(window.localStorage.getItem("cw-profile-new"));
                this.setState({
                    profile: profile
                }, () => {
                    this.props.getWatchListAction.fetchWatchList();
                    this.props.getTicketsAction.requestTickets();
                    this.setState({
                        events: this.filterEventsWithPath()
                    });
                });
            }
        };
        this.getUserProfile = () => {
            const { profile } = this.state;
            return profile ? profile.userName ? profile.userName : profile.email : '';
        };
        this.IsUserLoggedIn = () => {
            const { profile } = this.state;
            return profile && profile.token;
        };
        this.handleLogOut = () => {
            utils_1.logOut();
        };
        this.openMoreWatchlist = () => {
            this.setState({
                myWatchlistItemsDisplayed: this.state.myWatchlistItemsDisplayed + this.myWatchlistItemsPerPage
            });
        };
        this.openMoreTickets = () => {
            this.setState({
                myTicketsItemsDisplayed: this.state.myTicketsItemsDisplayed + this.myTicketsItemsPerPage
            });
        };
        this.renderLoading = (showWatchList) => {
            const { isLoadingWatchList, isLoadingTickets } = this.props;
            if ((showWatchList && isLoadingWatchList) || (!showWatchList && isLoadingTickets)) {
                return (React.createElement("div", { className: "level is-center" },
                    React.createElement("div", { className: "spinner" },
                        React.createElement("div", { className: "dot-1" }),
                        React.createElement("div", { className: "dot-2" }),
                        React.createElement("div", { className: "dot-3" }))));
            }
        };
        this.getMappedWatchLists = (myWatchListCards) => {
            const { events } = this.state;
            return myWatchListCards.map(myWatchlist => {
                let myUpdatedWatchList = null;
                let found = false;
                events.forEach(event => {
                    if (found) {
                        return;
                    }
                    const exists = myWatchlist.edis.indexOf(event.reference) > -1;
                    if (exists) {
                        found = true;
                        myUpdatedWatchList = { ...myWatchlist, link: event.link };
                    }
                });
                if (found) {
                    return myUpdatedWatchList;
                }
                return myWatchlist;
            });
        };
        this.renderFilter = () => {
            const selectedCategory = this.resolveSelectedCategory();
            let categories = this.getDistinctCategories();
            return (React.createElement("nav", { className: "filter" },
                React.createElement("div", { className: "tabs is-hidden-mobile" }, categories.map((category, i) => (React.createElement("a", { key: i, href: "#", className: `tab ${category === selectedCategory ? 'is-active' : ''}`, onClick: (e) => { e.preventDefault(); this.onCategorySelect.bind(this)(category); } }, category)))),
                React.createElement("div", { className: "is-hidden-tablet" },
                    React.createElement("div", { className: "input" },
                        React.createElement("select", { className: "", onChange: (e) => {
                                e.target.value === '' ?
                                    this.setState({ selectedCategory: null }) :
                                    this.setState({ selectedCategory: e.target.value });
                            } }, categories.map((category, i) => (React.createElement("option", { value: category, key: i }, category)))),
                        React.createElement("i", { className: "" },
                            React.createElement("img", { src: icons_1.arrowheadDownIcon, alt: "" }))))));
        };
        const preferredLanguage = props.preferredLanguage ? props.preferredLanguage : 'nb';
        moment.locale(preferredLanguage);
    }
    render() {
        if (!this.IsUserLoggedIn()) {
            return (React.createElement("div", null));
        }
        const { title, imagePlaceholder, bannerId, bannerMobileId, preferredLanguage } = this.props;
        const { selectedCategory } = this.state;
        let myWatchList = null;
        let myTickets = [];
        let myWatchListCards = [];
        const showWatchList = selectedCategory === null || selectedCategory === 'Interessert';
        if (showWatchList) {
            myWatchList = this.getMyWatchList();
            myWatchListCards = this.getMappedWatchLists(myWatchList);
        }
        else {
            myTickets = this.props.myTickets;
        }
        return (React.createElement("div", { className: "MyPage" },
            React.createElement("div", { className: "MyPage MyPage-header" },
                React.createElement("div", { className: "title" },
                    React.createElement("h1", null, title)),
                React.createElement("div", { className: "profile-wrapper" },
                    React.createElement("div", { className: "profile-icon" },
                        React.createElement("img", { src: icons_1.profileIcon, alt: "profile" })),
                    React.createElement("div", { className: "profile-user" },
                        React.createElement("div", { className: "profile-user profile-user_name" }, this.getUserProfile()),
                        React.createElement("div", { className: "profile-user profile-user_logout" },
                            React.createElement("a", { href: "/", onClick: this.handleLogOut }, " Logg ut "))))),
            this.renderFilter(),
            React.createElement("div", { className: "container" },
                this.renderLoading(showWatchList),
                showWatchList &&
                    React.createElement("div", { className: "row is-spaced" },
                        myWatchListCards.slice(0, this.state.myWatchlistItemsDisplayed).map((card, index) => (React.createElement("div", { key: index, className: "column is-lg-3 is-md-4 is-xs-12" },
                            React.createElement("div", { className: `watchlist ${card.link ? 'active' : 'not-active'}` },
                                React.createElement(Card_1.Card, { image: card.poster || imagePlaceholder, title: card.title, subtitle: card.link ? '' : 'Ingen forestillinger i salg', link: card.link ? card.link : null }))))),
                        myWatchListCards.length > this.state.myWatchlistItemsDisplayed &&
                            React.createElement("div", { className: "level is-center" },
                                React.createElement("button", { className: "button is-contained", onClick: this.openMoreWatchlist }, "Se flere"))),
                !showWatchList &&
                    React.createElement("div", { className: "row is-spaced" },
                        myTickets.slice(0, this.state.myTicketsitemsDisplayed).map((ticket, index) => (React.createElement("div", { key: index, className: "column is-lg-3 is-md-4 is-xs-12" },
                            React.createElement(Ticket_1.Ticket, { ticket: ticket, bannerId: bannerId, bannerMobileId: bannerMobileId, preferredLanguage: preferredLanguage })))),
                        myTickets.length > this.state.myTicketsitemsDisplayed &&
                            React.createElement("div", { className: "level is-center" },
                                React.createElement("button", { className: "button is-contained", onClick: this.openMoreTickets }, "Se flere"))))));
    }
    onCategorySelect(category) {
        this.setState({
            selectedCategory: category
        });
    }
    getMyWatchList() {
        const { watchList } = this.props;
        return watchList;
    }
    resolveSelectedCategory() {
        const { selectedCategory } = this.state;
        const categories = this.getDistinctCategories(true);
        if (selectedCategory !== null) {
            return this.state.selectedCategory;
        }
        let preselectMoviesCat = '';
        if (typeof categories['interested'] != 'undefined') {
            preselectMoviesCat = categories['interested'];
        }
        else if (typeof categories['myTickets'] !== 'undefined') {
            preselectMoviesCat = categories['myTickets'];
        }
        return preselectMoviesCat;
    }
    getDistinctCategories(returnMap = false) {
        let categories = {};
        if (returnMap) {
            categories["interested"] = "Interessert";
            categories["myTickets"] = "Mine billetter";
            return categories;
        }
        categories["Interessert"] = '';
        categories["Mine billetter"] = '';
        return Object.keys(categories);
    }
    filterEventsWithPath() {
        const { events } = this.props;
        const result = events.reduce((acc, currentValue) => {
            if (currentValue.link) {
                acc.push(currentValue);
            }
            return acc;
        }, []);
        return result;
    }
}
exports.MyPage = MyPage;
exports.default = react_redux_1.connect((state) => ({
    watchList: state.watchList.items,
    isLoadingWatchList: state.watchList.loading,
    myTickets: state.tickets.items,
    isLoadingTickets: state.tickets.loading
}), (dispatch) => ({
    getWatchListAction: redux_1.bindActionCreators(watchList_1.actionCreators, dispatch),
    getTicketsAction: redux_1.bindActionCreators(tickets_1.actionCreators, dispatch)
}))(MyPage);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-my-page/MyPage.tsx